var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wp-step2",on:{"mouseover":_vm.loadPopovers}},[_c('new-booking-flayer',{attrs:{"from-wp":true}}),_vm._v(" "),_c('new-package-section',{attrs:{"from-wp":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }